import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/logos/index.tsx
const RZDLogo = ({ className, ...props }) => /* @__PURE__ */ jsxs("svg", {
	viewBox: "0 0 68 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: cn(className),
	"aria-hidden": true,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "M48.1587 2.67298V3.77082H57.6113C58.2367 3.77082 59.1851 3.77082 59.8127 4.40402C60.4404 5.03274 60.4404 5.97681 60.4404 6.61018V16.0547C60.4404 16.6809 60.4404 17.6305 59.8127 18.2567C59.1851 18.8869 58.2367 18.8869 57.6113 18.8869H53.0451C52.2573 18.8869 51.2322 18.8869 50.8397 18.0192C50.4455 17.1557 50.9966 16.3679 51.4697 15.7377L57.6113 7.55741H48.1587L44.3867 12.5931C43.7558 13.4364 43.207 14.1665 43.207 15.1091C43.207 16.0547 43.7121 16.7365 44.3867 17.6305L45.3344 18.8869C46.2721 20.1455 47.2199 21.4067 48.4782 22.0363C49.7404 22.6641 51.2322 22.6641 53.2808 22.6641H57.3756C59.7339 22.6641 63.2798 22.6641 65.6381 20.3056C67.999 17.9422 67.999 14.4803 67.999 13.2178V9.44073C67.999 8.18114 67.999 4.71805 65.6381 2.35895C63.2798 -0.000806808 59.7339 -0.000810623 57.3756 -0.000810623H50.8397C50.2121 -0.000810623 49.4235 -0.000806808 48.7966 0.626245C48.1587 1.25646 48.1587 2.04127 48.1587 2.67298Z",
			fill: "#A43A41"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M36.8313 7.55671H46.2728L34.9421 22.668H25.498L36.8313 7.55671Z",
			fill: "#A43A41"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M0 10.2268C0 9.5999 0 8.81276 0.629216 8.18171C1.26006 7.55799 2.04379 7.55799 2.67617 7.55799H18.4942C20.5389 7.55799 22.0369 7.55799 23.2938 8.18171C24.554 8.81276 25.4976 10.073 26.447 11.3301L27.387 12.5937C28.0561 13.4862 28.569 14.1671 28.569 15.1097C28.569 16.0553 28.0223 16.7862 27.387 17.631L23.61 22.6692H14.1639L20.3031 14.4809C20.7778 13.8541 21.3281 13.0661 20.9355 12.196C20.5389 11.3301 19.5177 11.3301 18.7261 11.3301H11.3339V30.2227H3.77842V11.3301H0V10.2268Z",
			fill: "#A43A41"
		})
	]
});
const RZDLogoColorless = ({ className, ...props }) => /* @__PURE__ */ jsxs("svg", {
	viewBox: "0 0 68 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: cn(className),
	"aria-hidden": true,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "M48.1587 2.67298V3.77082H57.6113C58.2367 3.77082 59.1851 3.77082 59.8127 4.40402C60.4404 5.03274 60.4404 5.97681 60.4404 6.61018V16.0547C60.4404 16.6809 60.4404 17.6305 59.8127 18.2567C59.1851 18.8869 58.2367 18.8869 57.6113 18.8869H53.0451C52.2573 18.8869 51.2322 18.8869 50.8397 18.0192C50.4455 17.1557 50.9966 16.3679 51.4697 15.7377L57.6113 7.55741H48.1587L44.3867 12.5931C43.7558 13.4364 43.207 14.1665 43.207 15.1091C43.207 16.0547 43.7121 16.7365 44.3867 17.6305L45.3344 18.8869C46.2721 20.1455 47.2199 21.4067 48.4782 22.0363C49.7404 22.6641 51.2322 22.6641 53.2808 22.6641H57.3756C59.7339 22.6641 63.2798 22.6641 65.6381 20.3056C67.999 17.9422 67.999 14.4803 67.999 13.2178V9.44073C67.999 8.18114 67.999 4.71805 65.6381 2.35895C63.2798 -0.000806808 59.7339 -0.000810623 57.3756 -0.000810623H50.8397C50.2121 -0.000810623 49.4235 -0.000806808 48.7966 0.626245C48.1587 1.25646 48.1587 2.04127 48.1587 2.67298Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M36.8313 7.55671H46.2728L34.9421 22.668H25.498L36.8313 7.55671Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M0 10.2268C0 9.5999 0 8.81276 0.629216 8.18171C1.26006 7.55799 2.04379 7.55799 2.67617 7.55799H18.4942C20.5389 7.55799 22.0369 7.55799 23.2938 8.18171C24.554 8.81276 25.4976 10.073 26.447 11.3301L27.387 12.5937C28.0561 13.4862 28.569 14.1671 28.569 15.1097C28.569 16.0553 28.0223 16.7862 27.387 17.631L23.61 22.6692H14.1639L20.3031 14.4809C20.7778 13.8541 21.3281 13.0661 20.9355 12.196C20.5389 11.3301 19.5177 11.3301 18.7261 11.3301H11.3339V30.2227H3.77842V11.3301H0V10.2268Z",
			fill: "currentColor"
		})
	]
});
const ASULogo = ({ className, ...props }) => /* @__PURE__ */ jsxs("svg", {
	viewBox: "0 0 93 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: cn(className),
	"aria-hidden": true,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "M5.28 0.432H10.2L15.48 16.272V17.424H12.168L10.848 13.464H4.56L3.24 17.424H0V16.272L5.28 0.432ZM8.376 3.6H7.032C7.032 6.048 6.384 7.992 5.52 10.584H9.888C9.024 7.992 8.376 6.048 8.376 3.6Z",
			fill: "#A43A41"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M22.4638 0H23.0398C29.0158 0 29.0158 4.272 29.0158 5.712L25.6078 6.552C24.7918 3.288 24.7918 3.288 22.7518 3.288C19.9438 3.288 19.9438 3.288 19.9438 8.496V9.36C19.9438 14.568 19.9438 14.568 23.3998 14.568H24.3118L27.5758 13.752H28.5838V16.992C25.1278 17.856 23.8318 17.856 22.8238 17.856C16.1998 17.856 16.1998 13.032 16.1998 9.648V8.208C16.1998 5.256 16.1998 0 22.4638 0Z",
			fill: "#A43A41"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M35.1548 8.928H37.7708C37.7708 7.032 37.8668 6.768 39.9788 0.432H43.4347V1.584L39.4268 12.936C37.8428 17.424 36.1147 17.424 33.8348 17.424H31.9867V14.4H33.8587C35.2987 14.4 35.4908 14.376 35.8748 13.2L36.3307 11.832H33.1867L29.4188 1.584V0.432H32.8268C35.0588 6.768 35.1548 7.032 35.1548 8.928Z",
			fill: "#A43A41"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M54.5505 7.416H57.7185C59.6625 7.416 59.6625 7.344 59.6625 5.448C59.6625 3.456 59.5665 3.456 57.7185 3.456H54.5505V7.416ZM57.7185 10.44H54.5505V14.4H57.7185C59.6625 14.4 59.6625 14.328 59.6625 12.432C59.6625 10.44 59.5665 10.44 57.7185 10.44ZM51.0945 0.432H56.0625C59.6625 0.432 63.4785 0.432 63.4785 4.968C63.4785 6.552 62.7105 8.112 60.9825 8.664V9.192C63.4785 9.816 63.4785 12.24 63.4785 12.888C63.4785 17.424 59.8065 17.424 56.0625 17.424H51.0945V0.432Z",
			fill: "#A43A41"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M66.1423 0.432H69.5983V17.424H66.1423V0.432Z",
			fill: "#A43A41"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M72.9167 0.432H78.8927C82.1327 11.232 82.1327 11.232 82.1327 13.536H82.9967C82.9967 11.232 82.9967 11.232 86.2367 0.432H92.2127V17.424H88.8287V3.6H87.9647C87.9647 5.664 87.9647 5.664 84.4367 17.424H80.6927C77.1647 5.664 77.1647 5.664 77.1647 3.6H76.3007V17.424H72.9167V0.432Z",
			fill: "#A43A41"
		})
	]
});
const GGELogo = ({ className, ...props }) => /* @__PURE__ */ jsxs("svg", {
	width: "47",
	height: "36",
	viewBox: "0 0 47 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: cn(className),
	"aria-hidden": true,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "M8.19732 24.9136V18.2593L13.9813 14.9198V19.3951H15.6418V13.963L20.0615 11.4136L19.6603 10.7161L15.2405 13.2655L7.82695 8.95068L-0.000213623 13.5001V22.5001L7.82077 27.0556L13.0739 24.0001L12.2158 22.605L8.19732 24.9075V24.9136ZM7.39485 24.8828L1.6109 21.5927V14.8828L7.39485 18.2223V24.889V24.8828ZM2.01213 14.1791L7.82077 10.8704L13.6171 14.1976L7.82695 17.5371L2.01213 14.1791ZM7.82695 18.0001V17.9877L7.84547 18.0001H7.82695Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M38.8398 8.94434L31.4077 13.2715L27.0311 10.7468L26.6299 11.4443L31.0188 13.9814V19.395H32.6793V14.9382L38.4138 18.2468V24.8826L34.4509 22.611L33.5928 24.0061L38.8459 27.0616L46.6669 22.5061V13.5061L38.8459 8.95051L38.8398 8.94434ZM38.8336 17.5616L33.0311 14.2098L38.8398 10.8764L44.6669 14.1912L38.8274 17.5616H38.8336ZM45.0558 21.5925L39.2163 24.9135V18.2715L45.0558 14.9011V21.5925Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M35.4259 19.4877L30.7593 22.1852L23.4938 18.0062L28.2346 15.2716L27.4321 13.8272L23.7346 15.9383V9.24074L29.5185 5.90123V10.4444H31.179V4.5L23.3025 0L15.4815 4.5V10.4444H17.142V5.96914L22.9259 9.30864V15.963L19.2284 13.821L18.4259 15.2654L23.1173 18L15.9012 22.1975L11.6358 19.7346L11.2346 20.4321L15.4815 22.8827V31.5L23.3025 36L31.1234 31.4444V22.8951L35.8272 20.179L35.4259 19.4815V19.4877ZM17.5062 5.25309L23.3025 1.87654L29.0926 5.22222L23.2716 8.58025L17.5062 5.25309ZM23.3148 9.05556H23.2901L23.3025 9.03086L23.3148 9.05556ZM22.9321 33.9074L17.1481 30.537H17.0926V23.8086L22.9321 27.179V33.9012V33.9074ZM17.5494 23.1481L23.3086 19.821L29.0741 23.1543L23.3148 26.4753L17.5494 23.1481ZM29.5185 30.537L23.7346 33.8765V27.1605L29.5185 23.821V30.537Z",
			fill: "#3A72A4"
		})
	]
});
const GGEName = ({ className, ...props }) => /* @__PURE__ */ jsxs("svg", {
	width: "164",
	height: "16",
	viewBox: "0 0 164 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: cn(className),
	"aria-hidden": true,
	...props,
	children: [
		/* @__PURE__ */ jsx("path", {
			d: "M12.5198 0.212891V15.7874H9.32634V2.90225H3.61214V15.7874H0.410156V0.212891H12.5198Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M27.4562 0.212891V15.7874H24.2542V2.90225H20.0984V4.6214C20.0984 9.78736 19.894 11.4384 19.3235 12.8852C18.5911 14.7831 16.8538 15.7278 14.3672 16.0001V12.7065C15.3295 12.5278 16.0789 12.1448 16.4195 11.2597C16.8113 10.264 16.8964 8.4597 16.8964 4.6214V0.221403H27.4477L27.4562 0.212891Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M28.9127 15.7874L34.3969 0.212891H37.4541L42.9384 15.7874H39.532L38.5697 12.8342H33.2899L32.3275 15.7874H28.9041H28.9127ZM34.1414 10.1703H37.7096L35.9298 4.68949L34.15 10.1703H34.1414Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M54.0858 0.212891V2.90225H49.7427V15.7874H46.5492V2.90225H42.2061V0.212891H54.0858Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M61.3242 0.212891H64.5262V1.34481C68.1796 1.34481 70.9217 2.83417 70.9217 7.64268V8.36608C70.9217 13.1746 68.1796 14.664 64.5262 14.664V15.7959H61.3242V14.664C57.6709 14.664 54.9288 13.1746 54.9288 8.36608V7.64268C54.9288 2.83417 57.6709 1.34481 61.3242 1.34481V0.212891ZM61.3242 4.00864C59.2208 4.00864 58.1308 4.77459 58.1308 7.64268V8.36608C58.1308 11.2342 59.2293 12.0001 61.3242 12.0001V4.00864ZM64.5262 12.0001C66.6552 12.0001 67.7282 11.2342 67.7282 8.36608V7.64268C67.7282 4.77459 66.6552 4.00864 64.5262 4.00864V12.0001Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M79.0037 15.983C75.4611 15.983 72.9744 13.8638 72.9744 9.09787V6.88511C72.9744 2.0766 75.4611 0 79.0037 0C82.5463 0 85.0585 2.0766 85.0585 6.88511V9.09787C85.0585 13.8638 82.5719 15.983 79.0037 15.983ZM76.1679 9.09787C76.1679 12.0766 77.1472 13.3192 79.0037 13.3192C80.8602 13.3192 81.8565 12.0766 81.8565 9.09787V6.88511C81.8565 3.90638 80.8517 2.66383 79.0037 2.66383C77.1558 2.66383 76.1679 3.90638 76.1679 6.88511V9.09787Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M90.8747 10.2982V15.7791H87.6727V0.20459H93.3188C96.9466 0.20459 99.2118 1.85565 99.2118 5.19182C99.2118 8.528 96.9721 10.2897 93.3188 10.2897H90.8747V10.2982ZM92.8589 7.63438C95.0731 7.63438 96.0098 6.86842 96.0098 5.20033C96.0098 3.71097 95.0731 2.90246 92.8589 2.90246H90.8747V7.64289H92.8589V7.63438Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M108.579 8.698L112.965 0.212891H116.005V15.7874H112.948V6.12779L109.525 12.9874H107.583L104.202 6.19587V15.7874H101.162V0.212891H104.151L108.579 8.698Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M117.453 15.7874L122.937 0.212891H125.994L131.479 15.7874H128.072L127.11 12.8342H121.83L120.868 15.7874H117.444H117.453ZM122.682 10.1703H126.25L124.47 4.68949L122.69 10.1703H122.682Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M131.871 8H137.79V10.5277H131.871V8Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M142.899 6.41681H144.066C145.368 6.41681 146.263 5.73596 146.263 4.43383C146.263 3.39554 145.462 2.62958 144.295 2.62958C143.129 2.62958 142.465 3.32745 142.328 4.29766H139.493C139.603 1.74447 141.732 0.00830078 144.449 0.00830078C147.327 0.00830078 149.431 1.97426 149.431 4.29766C149.431 6.05936 148.332 7.14021 147.285 7.70192C148.63 8.35723 149.661 9.57426 149.661 11.4296C149.661 13.9572 147.881 15.9913 144.636 15.9913C141.392 15.9913 139.407 14.1445 139.288 11.6083H142.098C142.26 12.604 143.01 13.3274 144.432 13.3274C145.709 13.3274 146.493 12.4253 146.493 11.2764C146.493 9.89766 145.692 9.08915 144.074 9.08915H142.907V6.42532L142.899 6.41681Z",
			fill: "#3A72A4"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M152.351 15.7874V0.212891H157.946C161.506 0.212891 164.001 2.01715 164.001 6.98736V9.0214C164.001 13.9661 161.515 15.7959 157.946 15.7959H152.351V15.7874ZM160.799 9.01289V6.97885C160.799 4.28949 160.067 2.89374 157.946 2.89374H155.545V13.115H157.946C160.067 13.115 160.799 11.6937 160.799 9.00438V9.01289Z",
			fill: "#3A72A4"
		})
	]
});
//#endregion
export { ASULogo, GGELogo, GGEName, RZDLogo, RZDLogoColorless };

//# sourceMappingURL=index.js.map